import React, { useState } from "react";
import Paper from "@material-ui/core/Paper";
import {
  GeneralStyleMenuManagement,
  useStylesMenuManagement,
} from "./MenuManagementContainer.styled";
import HeaderComponent from "../../components/Header/Header";
import ClientAccessContainer from "../ClientAccessContainer/ClientAccessContainer";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import { ReactComponent as SurveyManagementIcon } from "../../assets/svg/survey-management-icon.svg";

const MenuManagementContainer = () => {
  const [selectedMenu, selectMenu] = useState(["add", "New User"]);
  const classes = useStylesMenuManagement();
  const [valueTabs, setValueTabs] = useState(0);

  const handleChange = (event, newValue) => {
    if (newValue === 0) selectMenu(["menu", "Menu"]);
    if (newValue === 1) selectMenu(["client", "Client"]);
    if (newValue === 2) selectMenu(["instanceAdmin", "Instance Admin"]);
    setValueTabs(newValue);
  };

  return (
    <>
      <GeneralStyleMenuManagement>
        <div className={classes.root}>
          <>
            <HeaderComponent
              Icon={SurveyManagementIcon}
              text={"Site Management"}
            ></HeaderComponent>
            <Paper position="static">
              <AntTabs
                aria-label="Menu Management"
                value={valueTabs}
                onChange={handleChange}
                style={{ overflowX: "auto" }}
              >
                <AntTab label="Menu" id="menu" />
                <AntTab label="Client" id="client" />
                <AntTab label="Instance Admin" id="instanceAdmin" />
              </AntTabs>
            </Paper>

            {selectedMenu[0] === "client" && (
              <ClientAccessContainer></ClientAccessContainer>
            )}
          </>
        </div>
      </GeneralStyleMenuManagement>
    </>
  );
};

export default MenuManagementContainer;
